/** Valores truthy de flags en common.domains.config → trackvision. */
export function isDomainConfigFlagEnabled(value: unknown): boolean {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/** Campo de tipo / subtipo de contrato (Services tipo 20 o Flows campo «Tipo»). */
export function isContractTipoSubtypeField(field: { type?: number; name?: string } | null | undefined): boolean {
  if (!field) {
    return false;
  }
  if (Number(field.type) === 20) {
    return true;
  }
  if (Number(field.type) === 14) {
    const name = (field.name || '').trim().toLowerCase();
    return name === 'tipo' || name === 'tipo contrato';
  }
  return false;
}

/** Ocultar subtipo cuando el tenant tiene trackvision.hideContractSubtype. */
export function shouldHideContractSubtypeForTenantFlag(
  tenantHideContractSubtype: boolean,
  field: { type?: number; name?: string } | null | undefined
): boolean {
  return tenantHideContractSubtype && isContractTipoSubtypeField(field);
}

/** @deprecated Usar shouldHideContractSubtypeForTenantFlag + domain config. */
export const shouldHideContractSubtypeForHites = shouldHideContractSubtypeForTenantFlag;

/** Catálogo Services tipo 20 con al menos un subtipo cargado. */
export function contractSubtypeCatalogEnabled(values: { subtype?: { data?: { items?: unknown[] }[] } } | null | undefined): boolean {
  const data = values && values.subtype && values.subtype.data;
  if (!Array.isArray(data)) {
    return false;
  }
  return data.some((row) => Array.isArray(row.items) && row.items.length > 0);
}

/** Ocultar subtipo: flag de dominio; otros tenants si el catálogo no trae subtipos (tipo 20). */
export function shouldHideContractSubtype(
  tenantHideContractSubtype: boolean,
  field: { type?: number; name?: string; values?: unknown } | null | undefined
): boolean {
  if (!isContractTipoSubtypeField(field)) {
    return false;
  }
  if (tenantHideContractSubtype) {
    return true;
  }
  if (Number(field.type) === 20) {
    return !contractSubtypeCatalogEnabled(field.values as { subtype?: { data?: { items?: unknown[] }[] } });
  }
  return false;
}

function normalizeFlowsColumnHeaderName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
}

/** Columna de grilla Flows del campo «Tipo» de contrato (no División ni otros type-14). */
export function isFlowsTipoColumnHeader(header: { name?: string } | null | undefined): boolean {
  const n = normalizeFlowsColumnHeaderName(header?.name || '');
  return n === 'tipo' || n === 'tipo / subtipo' || n === 'tipo/subtipo';
}

/** Al crear registro en Hites: no persistir subtipo; en edición conservar valor histórico en BD. */
export function shouldStripContractSubtypeOnSave(
  tenantHideContractSubtype: boolean,
  field: { type?: number; name?: string; values?: unknown } | null | undefined,
  options: { edit?: boolean; context?: string }
): boolean {
  if (options.edit) {
    return false;
  }
  if (options.context && options.context !== 'creation') {
    return false;
  }
  return shouldHideContractSubtype(tenantHideContractSubtype, field);
}
